import { SignatureAlgorithmName } from "@/lib/helpers/restore-wallets";

interface CryptoInfo {
  name: string;
  symbol: string;
  derivationPath: number[];
  signatureAlgorithm: SignatureAlgorithmName;
}

export type NetworkKey = keyof typeof cryptocurrencies;

export const cryptocurrencies: Record<string, CryptoInfo> = {
  BNB: {
    name: "BNB",
    symbol: "BNB",
    derivationPath: [44, 60, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ECDSA,
  },
  BTC: {
    name: "Bitcoin",
    symbol: "BTC",
    derivationPath: [84, 0, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ECDSA,
  },
  DOGE: {
    name: "Dogecoin",
    symbol: "DOGE",
    derivationPath: [44, 3, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ECDSA,
  },
  ETH: {
    name: "Ethereum",
    symbol: "ETH",
    derivationPath: [44, 60, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ECDSA,
  },
  AVAX: {
    name: "Avalanche C-Chain",
    symbol: "AVAX",
    derivationPath: [44, 60, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ECDSA,
  },
  POL: {
    name: "Polygon",
    symbol: "POL",
    derivationPath: [44, 60, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ECDSA,
  },
  BCH: {
    name: "Bitcoin Cash",
    symbol: "BCH",
    derivationPath: [44, 145, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ECDSA,
  },
  XRP: {
    name: "Ripple",
    symbol: "XRP",
    derivationPath: [44, 144, 0, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ECDSA,
  },
  SOL: {
    name: "Solana",
    symbol: "SOL",
    derivationPath: [44, 501, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ED25519,
  },
  XLM: {
    name: "Stellar Network",
    symbol: "XLM",
    derivationPath: [44, 148, 0, 0],
    signatureAlgorithm: SignatureAlgorithmName.ED25519,
  },
} as const;
